import React from 'react'
import { Spinner } from 'react-bootstrap'

import { useAccount } from '../../../common/useAccount'

import { BusinessEventsDisabledBanner } from '../../../components/BusinessEvent/BusinessEventsDisabledBanner/BusinessEventsDisabledBanner'
import { ZapierPromoBanner } from '../../../components/BusinessEvent/ZapierPromoBanner/ZapierPromoBanner'
import { BusinessEventList } from '../../../components/BusinessEvent/BusinessEventList/BusinessEventList'
import { useZocksQuota } from '../../../components/ScopedBlock/hooks'

import { selectBusinessEvents, selectBusinessEventsLoading } from '../../../store/businessEvent/businessEvent'
import { useAppSelector } from '../../../store/hooks'

import { User } from '../../../models/User'

import { DELTA_TRIAL_FEATURES } from '../../Plan/DeltaTrial/DeltaTrialFeatures'
import { Upsell } from '../../Plan/DeltaTrial/Upsell/Upsell'

import { ContactBusinessEventsInitialization } from './ContactBusinessEventsInitialization'

import './ContactBusinessEvents.scss'

interface ContactBusinessEventsProps {
  contact: User
}

export const ContactBusinessEvents: React.FC<ContactBusinessEventsProps> = ({ contact }) => {
  const { hasQuota } = useZocksQuota()

  const businessEventsEnabled = hasQuota('ai.businessEvent.value')

  if (!businessEventsEnabled) {
    return <Upsell feature={DELTA_TRIAL_FEATURES['businessEvents']} />
  }

  return (
    <>
      <ContactBusinessEventsInitialization contactId={contact.id} />
      <ContactBusinessEventsContent />
    </>
  )
}

export const ContactBusinessEventsContent: React.FC = () => {
  const businessEvents = useAppSelector(selectBusinessEvents)
  const isLoading = useAppSelector(selectBusinessEventsLoading)

  const { account } = useAccount({ refetchOnMountOrArgChange: false })

  if (isLoading) {
    return (
      <div className='d-flex align-items-center justify-content-center'>
        <Spinner />
      </div>
    )
  }

  return (
    <div className='d-flex flex-column zocks-gap-1.25'>
      <ZapierPromoBanner orientation='horizontal' />
      {!account?.effectiveConfig.businessEvent ? (
        <BusinessEventsDisabledBanner />
      ) : !businessEvents.length ? (
        <div className='d-flex align-items-center justify-content-center contact-business-events-empty-container rounded-2 zocks-bg-color-gray-100 border zocks-border-color-gray-300'>
          <span className='paragraph-medium zocks-text-gray-600'>No Client Signals detected for this contact yet.</span>
        </div>
      ) : null}
      <BusinessEventList showSource={true} showCreatedAt={true} />
    </div>
  )
}
